/**
 * Lightweight environment accessor that works in Vite (browser) and Node.
 * It first tries `import.meta.env` (Vite), then falls back to `process.env`.
 */
export const getEnv = (key: string, fallback: string = ''): string => {
  try {
    // Vite runtime (browser). Use direct references so Vite injects them at build time.
    if (typeof import.meta !== 'undefined' && import.meta.env) {
      switch (key) {
        case 'VITE_APP_ENV':
          return import.meta.env.VITE_APP_ENV?.toString().trim() ?? fallback;
        case 'VITE_AI_API_URL':
          return import.meta.env.VITE_AI_API_URL?.toString().trim() ?? fallback;
        case 'VITE_AI_API_KEY':
          return import.meta.env.VITE_AI_API_KEY?.toString().trim() ?? fallback;
        case 'VITE_SITE_URL':
          return import.meta.env.VITE_SITE_URL?.toString().trim() ?? fallback;
        case 'VITE_IS_MAINTENANCE':
          return import.meta.env.VITE_IS_MAINTENANCE?.toString().trim() ?? fallback;
        default:
          break;
      }
    }
  } catch {}

  try {
    // Node/SSR or test
    const v = typeof process !== 'undefined' ? process.env?.[key] : undefined;
    if (typeof v === 'string' && v.length > 0) return v.toString().trim();
  } catch {}

  return fallback;
};

export const getBooleanEnv = (key: string, fallback = false): boolean => {
  const raw = getEnv(key, fallback ? 'true' : 'false').trim().toLowerCase();
  return raw === '1' || raw === 'true' || raw === 'yes' || raw === 'on';
};
